import styled from "@emotion/styled";

export const StyledUpdateCasesForms = styled.div`
  .ant-upload-drag {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    padding: 40px 0px;
    background: #fafafa;
    cursor: pointer;
    transition:
      border-color 0.3s,
      background 0.3s;
    margin-bottom: 24px;

    &:hover {
      border-color: var(--primary);
      background: #f0f5ff;
    }

    .upload-icon {
      font-size: 50px;
      color: var(--primary);
      margin-bottom: 12px;
    }

    .upload-text {
      font-size: 15px;
      color: #333;
      font-weight: 500;
    }

    .upload-hint {
      font-size: 12px;
      color: #999;
      margin-top: 4px;
    }
  }

  .validation-error {
    margin-bottom: 16px;
  }

  .file-info {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    border-radius: 6px;
    padding: 10px 16px;
    margin-bottom: 16px;

    .file-name {
      font-weight: 500;
      color: #333;
      flex: 1;
    }

    .file-count {
      font-size: 12px;
      color: #52c41a;
      font-weight: 500;
    }
  }

  .batch-progress-section {
    margin-top: 16px;

    .batch-title {
      font-size: 13px;
      color: #555;
      margin-bottom: 10px;
      font-weight: 500;
    }

    .batch-item {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 8px 12px;
      border-radius: 6px;
      background: #f5f5f5;
      margin-bottom: 8px;
      transition: background 0.2s;

      &.pending {
        background: #f5f5f5;
      }

      &.processing {
        background: #e6f4ff;
        border: 1px solid #91caff;
      }

      &.success {
        background: #f6ffed;
        border: 1px solid #b7eb8f;
      }

      &.error {
        background: #fff2f0;
        border: 1px solid #ffccc7;
      }

      .batch-label {
        font-size: 13px;
        color: #333;
        flex: 1;
      }

      .batch-status-icon {
        font-size: 16px;
      }
    }
  }
`;
